import React, { useEffect, useState } from "react";
import { Loader2, Search, Square, SquareCheckBig } from "lucide-react";
import { toast } from "react-toastify";
import { getData } from "~/functions/gridFunctions";
import ModalShell from "../../Gravity Conciliation/Preview/ModalShell";
import {
  theme,
  field,
  primaryButton,
  ghostButton,
} from "../../Gravity Conciliation/Preview/modalStyles";

export default function PaymentMethodModal({ selectedId, onSelect, onClose }) {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");

  async function loadData(searchValue = null) {
    setLoading(true);
    try {
      const data = await getData("paymentmethods", {
        limit: 50,
        search: searchValue ? { value: searchValue } : null,
      });
      setRows(data || []);
    } catch (err) {
      toast("Could not load payment methods.", {
        type: "error",
        autoClose: 3000,
      });
      setRows([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  function handleSearch(event) {
    event.preventDefault();
    loadData(search);
  }

  return (
    <ModalShell
      title="Filter by payment method"
      onClose={onClose}
      maxWidth={480}
      zIndex={10000}
      draggable
    >
      <form
        onSubmit={handleSearch}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: 16,
          borderBottom: `1px solid ${theme.border}`,
          flexShrink: 0,
        }}
      >
        <input
          type="text"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Type to search..."
          style={{ ...field, flex: 1, width: "auto" }}
        />
        <button type="submit" style={primaryButton}>
          <Search size={14} /> Search
        </button>
      </form>

      <div style={{ flex: 1, minHeight: 0, overflowY: "auto", padding: 16 }}>
        {loading ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              padding: "32px 0",
              color: theme.muted,
            }}
          >
            <Loader2 size={16} className="animate-spin" /> Loading...
          </div>
        ) : rows.length === 0 ? (
          <div
            style={{ textAlign: "center", color: theme.muted, padding: "32px 0" }}
          >
            No payment methods found.
          </div>
        ) : (
          <table
            style={{
              width: "100%",
              border: `1px solid ${theme.border}`,
              borderRadius: 6,
              borderCollapse: "collapse",
            }}
          >
            <tbody>
              {rows.map((row) => {
                const checked = selectedId === row.id;
                return (
                  <tr
                    key={row.id}
                    onClick={() => onSelect(row)}
                    style={{
                      cursor: "pointer",
                      borderBottom: `1px solid ${theme.border}`,
                      backgroundColor: checked ? theme.successBg : "transparent",
                    }}
                  >
                    <td style={{ padding: 8, width: 32 }}>
                      {checked ? (
                        <SquareCheckBig size={16} color={theme.success} />
                      ) : (
                        <Square size={16} color={theme.border} />
                      )}
                    </td>
                    <td style={{ padding: 8 }}>{row.description || "-"}</td>
                    <td style={{ padding: 8, color: theme.muted }}>
                      {row.platform || ""}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      <div
        style={{
          borderTop: `1px solid ${theme.border}`,
          backgroundColor: theme.subtle,
          padding: 16,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
          flexShrink: 0,
        }}
      >
        <button
          type="button"
          onClick={() => onSelect(null)}
          style={ghostButton}
          disabled={!selectedId}
        >
          Clear filter
        </button>
        <button type="button" onClick={onClose} style={ghostButton}>
          Close
        </button>
      </div>
    </ModalShell>
  );
}
